export default "__VITE_ASSET__BavJUGl2__"